// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ButtonIcon_btnIcon__oIt1z{
    width: 14px;
    height: 14px;
    line-height: 14px;
    vertical-align: text-top;
    background-position: 14px 14px;
    background-repeat: no-repeat;
    font-weight: normal;
    font-style: normal;
    font-variant: normal;
    speak: none;
    text-decoration: inherit;
    text-transform: none;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    color: var(--color-icon-secondary);
}
.ButtonIcon_btnIcon__oIt1z:not([disabled]):hover{
    color: var(--color-icon-secondary-hover);
}
/* Large Button */
.ButtonIcon_btnIcon__oIt1z.ButtonIcon_btnIconLarge__52sLT {
    font-size: 33px;
    width: 34px;
    height: 34px;
}
/* Medium Button */
.ButtonIcon_btnIcon__oIt1z.ButtonIcon_btnIconMedium__uHGzF {
    font-size: 23px;
    width: 24px;
    height: 24px;
}
/* Small Button - default if not specified */
.ButtonIcon_btnIcon__oIt1z.ButtonIcon_btnIconSmall__xnxN1 {
    font-size: 13px;
    width: 14px;
    height: 14px;
}
/* Disabled icon */
.ButtonIcon_btnIcon__oIt1z[disabled] {
    cursor: not-allowed;
    text-shadow: none;
    color: var(--color-icon-secondary);
    outline: 0;
}

.ButtonIcon_btnIcon__oIt1z.ButtonIcon_hideOutline__5A\\+vH {
    outline: 0;
}

/* Map Theme - currently does not support multiple sizes */

.ButtonIcon_btnMap__VY7CX {
    width: 33px;
    height: 33px;
    float: left;
    margin-right: 6px;
    color: var(--color-icon-secondary-dark);
    border-radius: 20px;

    background: var(--color-141);
    box-shadow: 0 0 2px var(--color-103);

    cursor: pointer;

    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;

    font-weight: normal;
    vertical-align: top;
    line-height: 22px;

    border: none;
    padding: 0;
    margin: 0;
    outline: none;
}

.ButtonIcon_btnMap__VY7CX:hover { color:var(--color-icon-secondary-hover); }
.ButtonIcon_btnMap__VY7CX:focus { color:var(--color-icon-secondary-dark); }

.ButtonIcon_btnIconMap__H11GW {
    width: 15px;
    height: 15px;
    font-size: 13px;
    margin-top: 2px;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/ButtonIcon/ButtonIcon.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,wBAAwB;IACxB,oBAAoB;IACpB,oBAAoB;IACpB,mCAAmC;IACnC,kCAAkC;AACtC;AACA;IACI,wCAAwC;AAC5C;AACA,iBAAiB;AACjB;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;AACA,kBAAkB;AAClB;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;AACA,4CAA4C;AAC5C;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;AACA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA,0DAA0D;;AAE1D;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;;IAEnB,4BAA4B;IAC5B,oCAAoC;;IAEpC,eAAe;;IAEf,uHAAuH;;IAEvH,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;;IAEjB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,aAAa;AACjB;;AAEA,kCAAgB,uCAAuC,EAAE;AACzD,kCAAgB,sCAAsC,EAAE;;AAExD;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB","sourcesContent":[".btnIcon{\n    width: 14px;\n    height: 14px;\n    line-height: 14px;\n    vertical-align: text-top;\n    background-position: 14px 14px;\n    background-repeat: no-repeat;\n    font-weight: normal;\n    font-style: normal;\n    font-variant: normal;\n    speak: none;\n    text-decoration: inherit;\n    text-transform: none;\n    text-rendering: auto;\n    -webkit-font-smoothing: antialiased;\n    color: var(--color-icon-secondary);\n}\n.btnIcon:not([disabled]):hover{\n    color: var(--color-icon-secondary-hover);\n}\n/* Large Button */\n.btnIcon.btnIconLarge {\n    font-size: 33px;\n    width: 34px;\n    height: 34px;\n}\n/* Medium Button */\n.btnIcon.btnIconMedium {\n    font-size: 23px;\n    width: 24px;\n    height: 24px;\n}\n/* Small Button - default if not specified */\n.btnIcon.btnIconSmall {\n    font-size: 13px;\n    width: 14px;\n    height: 14px;\n}\n/* Disabled icon */\n.btnIcon[disabled] {\n    cursor: not-allowed;\n    text-shadow: none;\n    color: var(--color-icon-secondary);\n    outline: 0;\n}\n\n.btnIcon.hideOutline {\n    outline: 0;\n}\n\n/* Map Theme - currently does not support multiple sizes */\n\n.btnMap {\n    width: 33px;\n    height: 33px;\n    float: left;\n    margin-right: 6px;\n    color: var(--color-icon-secondary-dark);\n    border-radius: 20px;\n\n    background: var(--color-141);\n    box-shadow: 0 0 2px var(--color-103);\n\n    cursor: pointer;\n\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n\n    font-weight: normal;\n    vertical-align: top;\n    line-height: 22px;\n\n    border: none;\n    padding: 0;\n    margin: 0;\n    outline: none;\n}\n\n.btnMap:hover { color:var(--color-icon-secondary-hover); }\n.btnMap:focus { color:var(--color-icon-secondary-dark); }\n\n.btnIconMap {\n    width: 15px;\n    height: 15px;\n    font-size: 13px;\n    margin-top: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnIcon": `ButtonIcon_btnIcon__oIt1z`,
	"btnIconLarge": `ButtonIcon_btnIconLarge__52sLT`,
	"btnIconMedium": `ButtonIcon_btnIconMedium__uHGzF`,
	"btnIconSmall": `ButtonIcon_btnIconSmall__xnxN1`,
	"hideOutline": `ButtonIcon_hideOutline__5A+vH`,
	"btnMap": `ButtonIcon_btnMap__VY7CX`,
	"btnIconMap": `ButtonIcon_btnIconMap__H11GW`
};
export default ___CSS_LOADER_EXPORT___;
